/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Correlation_CoefficientInputs */

const en_admin_statistics_correlation_coefficient = /** @type {(inputs: Admin_Statistics_Correlation_CoefficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correlation (r)`)
};

const de_admin_statistics_correlation_coefficient = /** @type {(inputs: Admin_Statistics_Correlation_CoefficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrelation (r)`)
};

/**
* | output |
* | --- |
* | "Correlation (r)" |
*
* @param {Admin_Statistics_Correlation_CoefficientInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_correlation_coefficient = /** @type {((inputs?: Admin_Statistics_Correlation_CoefficientInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Correlation_CoefficientInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_correlation_coefficient(inputs)
	return en_admin_statistics_correlation_coefficient(inputs)
});